<script>
import {Line} from 'vue-chartjs';

const _ = require('lodash');

export default {
  extends: Line,
  props: ["chartData", "options"],
  mounted() {
    this.renderLineChart();
  },
  data: function () {
    return {
    };
  },
  methods: {
    renderLineChart: function () {
      this.renderChart(
        _.cloneDeep(this.chartData), _.cloneDeep(this.options)

      );
    }
  },
  watch: {
    chartData: {
      handler: function () {
        this.renderLineChart();
      },
      deep: true
    }
  },
}
</script>
